import type { ViewState } from "./canvas-coordinates";

const KEY_PREFIX = "refinement-canvas:view:";

export function loadCanvasView(canvasId: string): ViewState | null {
  try {
    const raw = window.localStorage.getItem(`${KEY_PREFIX}${canvasId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ViewState>;
    if (
      typeof parsed.panX !== "number" ||
      typeof parsed.panY !== "number" ||
      typeof parsed.zoom !== "number"
    ) {
      return null;
    }
    return { panX: parsed.panX, panY: parsed.panY, zoom: parsed.zoom };
  } catch {
    return null;
  }
}

export function saveCanvasView(canvasId: string, view: ViewState): void {
  try {
    window.localStorage.setItem(`${KEY_PREFIX}${canvasId}`, JSON.stringify(view));
  } catch {
    // localStorage の容量不足などでは表示位置保存のみ諦める。
  }
}
